import React, { useState } from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { useEffect } from 'react';
import GreetingCard from './greetings/GreetingCard';
import {
  getDashboardData,
  getDashboardDataChart
} from 'nursd-dashboard/api/dashboard';
import EcomStat from './greetings/EcomStat';
import { totalOrder } from 'data/dashboard/default';
import Weather from '../default/Weather';
import LicenseTypes from './LicenseTypes';
import PieChart from './PieChart';
import LineChart from './LineChart';
import Flex from 'components/common/Flex';
import FillBarChat from './FillBarChat';
import WeekDate from './WeekDate';
import TotalCount from './TotalCount';
import paths from 'routes/paths';
import { getOrganizationDetails } from 'nursd-dashboard/api/organizationTable';

const Dashboard = () => {
  const [tab, setTab] = useState('Shift');
  const [type, setType] = useState('Shift');
  const [orgDetail, setOrgDetail] = useState(undefined);
  const [locationWeather, setLocationWeather] = useState('');
  const [dashboardMatrix, setDashboardMatrix] = useState(undefined);
  const [dashboardMatrixLoading, setDashboardMatrixLoading] = useState(false);
  const [chartData, setChartData] = useState(false);
  const [fillBarChat, setFillBarChat] = useState(false);
  const [dataProgressChart, setDataProgressChart] = useState(false);

  const { authToken, location, organization, userId } = useAuth();

  const date = new Date();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(
    new Date(date.setDate(date.getDate() + 7))
  );
  const [refresh, setRefresh] = useState(true);

  const getDashboardDataFunction = async type => {
    setDashboardMatrixLoading(true);
    try {
      const data = await getDashboardData(
        authToken,
        type,
        location,
        organization
      );
      // console.log(data);
      setDashboardMatrix(data);
      setDashboardMatrixLoading(false);
    } catch (error) {
      setDashboardMatrix(undefined);
      setDashboardMatrixLoading(false);
    }
  };

  const getOgrDetail = async () => {
    try {
      const data = await getOrganizationDetails(authToken, userId);
      // console.log(data);
      setOrgDetail(data);
    } catch (error) {
      setOrgDetail(undefined);
    }
  };

  const getChartData = async (id, type, startDate, endDate) => {
    await getDashboardDataChart(authToken, id, type, startDate, endDate)
      .then(res => {
        // console.log(res);
        setChartData(res?.chartData);
        setDataProgressChart(res?.dataProgressChart);
        setFillBarChat(res?.fillBarChat);
      })
      .catch(e => console.log(e));
  };

  useEffect(() => {
    if (location !== '') {
      getDashboardDataFunction(tab);
      getChartData(1, type, startDate, endDate);
      getOgrDetail();
    }
  }, [authToken, tab, location, organization]);

  useEffect(() => {
    if (location !== '') {
      getChartData(1, type, startDate, endDate);
    }
  }, [refresh]);

  useEffect(() => {
    if (location !== '' && orgDetail) {
      let item = orgDetail?.locations?.find(i => i.location_id === location);
      const API_KEY = '60e15448320d2913356dc3e37fd4abf4';
      // const URL = `https://api.openweathermap.org/data/2.5/weather?q=${item?.location_state}&appid=${API_KEY}`;
      const URL = `https://api.openweathermap.org/data/2.5/weather?zip=${item?.location_zipCode},us&appid=${API_KEY}`;
      // console.log(URL);
      fetch(URL)
        .then(res => res.json())
        .then(data => setLocationWeather(data))
        .catch(err => console.log(err));
    }
  }, [location, orgDetail]);

  // console.log(locationWeather);

  return (
    <>
      {dashboardMatrixLoading ? (
        <Card>
          <p className="m-3">Loading...</p>
        </Card>
      ) : (
        <Row>
          <Row className="g-3">
            <Col md={3} xxl={3}>
              <TotalCount
                data={totalOrder}
                numberData={dashboardMatrix?.orderValue}
                label={'Total Order'}
                link={paths.nursd_order}
              />
            </Col>
            <Col md={3} xxl={3}>
              <TotalCount
                data={totalOrder}
                numberData={dashboardMatrix?.activeCustomer}
                label={'Active Patient'}
                link={paths.nursd_customer}
              />
            </Col>
            <Col md={3} xxl={3}>
              <TotalCount
                data={totalOrder}
                numberData={dashboardMatrix?.activeHospital}
                label={'Active Facility'}
                link={paths.nursd_facility}
              />
            </Col>
            {location !== 'All' && locationWeather && (
              <Col md={3} xxl={3}>
                <Weather locationWeather={locationWeather} />
              </Col>
            )}
          </Row>
          <Col sm={8} className="mt-4">
            <GreetingCard
              type={tab}
              location={location}
              dashboardMatrix={dashboardMatrix}
            />
          </Col>
          <Col sm={4} className="mt-4">
            <Card>
              <Flex className={'flex-1 mt-2 mx-2'}>
                <Button
                  className={'flex-1'}
                  style={{
                    backgroundColor: '#fff',
                    color: '#000',
                    outline: 0,
                    borderWidth: 0,
                    borderBottomWidth: 2,
                    borderBottomColor: tab === 'Shift' ? '#00B0F0' : '#fff',
                    borderRadius: 0
                  }}
                  onClick={() => setTab('Shift')}
                >
                  Shift
                </Button>
                <Button
                  className={'flex-1'}
                  style={{
                    backgroundColor: '#fff',
                    color: '#000',
                    outline: 0,
                    borderWidth: 0,
                    borderBottomWidth: 2,
                    borderBottomColor: tab === 'Visit' ? '#00B0F0' : '#fff',
                    borderRadius: 0
                  }}
                  onClick={() => setTab('Visit')}
                >
                  Visit
                </Button>
              </Flex>
              <EcomStat type={tab} dashboardMatrix={dashboardMatrix} />
            </Card>
          </Col>
          {dashboardMatrix && (
            <Row className="g-3">
              <Col md={12} xxl={12}>
                <LicenseTypes
                  count={dashboardMatrix?.nurseMatrix?.count}
                  data={dashboardMatrix?.nurseMatrix?.values}
                  radius={['100%', '87%']}
                />
              </Col>
            </Row>
          )}
          <Row className="g-3 h-100 mt-3 align-items-center">
            <h6 className="text-700 mb-0 text-nowrap">Showing Data For:</h6>
            <Col xs="auto">
              <Form.Select
                onChange={e => {
                  if (e.target.value !== '') {
                    getChartData(1, e.target.value, startDate, endDate);
                    setType(e.target.value);
                  } else {
                    getChartData(1, e.target.value, startDate, endDate);
                    setType(e.target.value);
                  }
                }}
                size="sm"
                value={type}
                className="mx-1"
              >
                {['All', 'Shift', 'Visit']?.map(option => (
                  <option key={option}>{option}</option>
                ))}
              </Form.Select>
            </Col>
            <Col md="auto">
              <WeekDate
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                refresh={refresh}
                setRefresh={setRefresh}
              />
            </Col>
          </Row>
          <Row className="g-3">
            <Col md={6} xxl={6}>
              <PieChart dataDB={dataProgressChart} width={200} height={200} />
            </Col>
            {chartData && (
              <Col md={6} xxl={6}>
                <LineChart dataDB={chartData} width={200} height={200} />
              </Col>
            )}
            <Col md={6} xxl={6}>
              <FillBarChat dataDB={fillBarChat} width={200} height={200} />
            </Col>
          </Row>
        </Row>
      )}
    </>
  );
};

export default Dashboard;
